import React, { useState, useRef } from 'react';
import { Mail, Phone, MapPin, Send, Download } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { toast } from 'sonner';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef(); // Référence nécessaire pour EmailJS
  const [submitting, setSubmitting] = useState(false);

  // État pour les champs contrôlés (optionnel avec EmailJS mais utile pour vider le form)
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    servings: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);

    // REMPLACEZ CES 3 VALEURS PAR LES VÔTRES (Dispo sur le dashboard EmailJS)
    const SERVICE_ID = 'service_efby3uc'; // ID de votre service SMTP OVH
    const TEMPLATE_ID = 'template_k3vgt5h'; // ID de votre modèle
    const PUBLIC_KEY = '3kD8scqcvs6uij0Fp'; // Votre clé publique

    // Envoi via EmailJS
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
          console.log('Email envoyé:', result.text);
          toast.success('Votre message a été envoyé avec succès ! Nous vous recontacterons bientôt sur votre adresse OVH.');
          
          // Vider le formulaire
          setFormData({
            name: '',
            email: '',
            phone: '',
            company: '',
            servings: '',
            message: ''
          });
      }, (error) => {
          console.error('Erreur:', error.text);
          toast.error("Erreur lors de l'envoi. Vérifiez votre connexion ou appelez-nous directement.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div className="contact-page pt-20">
      {/* Hero Section */}
      <section className="py-24 bg-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Titre agrandi et forcé en Brun */}
          <h1 
            className="page-title text-center mb-6 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold"
            style={{ color: '#C24D36' }}
          >
            Contactez-nous
          </h1>
          
          {/* Sous-titre agrandi et en gras */}
          <p className="text-xl sm:text-2xl md:text-3xl text-center text-[#F9F6F0] max-w-6xl mx-auto font-bold">
            Vous avez un projet de restauration collective ? Parlons-en ensemble.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="section-title mb-8 text-4xl md:text-5xl" style={{ color: '#C24D36' }}>Nos Coordonnées</h2>
              <div className="space-y-6 mb-12">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <Mail className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Email</h3>
                    <p className="text-gray-600">
                      <a href="mailto:contact@soulkitchenandco.fr" className="text-[#3E332E] hover:text-[#C24D36] transition-colors">contact@soulkitchenandco.fr</a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <Phone className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Téléphone</h3>
                    <p className="">
                      <a href="tel:+33626291294" className="text-[#3E332E] hover:text-[#C24D36] transition-colors">+33 6 26 29 12 94</a>
                      </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <MapPin className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Adresse</h3>
                    <p className="">
                      <a 
                      href="https://www.google.com/maps?q=2646+route+de+Peyraube+30770+Arrigas" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#3E332E] hover:text-[#C24D36] transition-colors text-left"
                    >
                      2646 Route de Peyraube, 30770 Arrigas
                    </a>

                    </p>
                  </div>
                </div>
              </div>

              <div
                className="w-full block bg-[#E5D07B] hover:bg-[#5A6C45] text-[#3E332E] hover:text-white font-bold rounded-lg py-3 px-8 shadow-md mt-6 text-center transition-all duration-300 transform hover:scale-105"
              >
                Nous vous recontactons sous 48h
              </div>

              {/* NOUVEAU BLOC FLYER */}
              <div className="mt-10 bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100 text-center">
                <p className="text-lg text-[#3E332E] font-medium mb-4">
                  Télécharger notre flyer pour en savoir plus sur l'esprit de Soul'Kitchen!
                </p>
                <a 
                  href="/images/Soul kitchen and co - Flyer.pdf" 
                  download="Soul kitchen and co - Flyer.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary hover:!bg-[#DDBA6B] transition-colors inline-flex items-center justify-center justify-center min-w-[230px] sm:w-auto"
                >
                  Telecharger notre flyer
                  <Download className="ml-2" size={20} />
                </a>
              </div>

              {/* Cadre jaune à la place du bouton envoyer la demande */}
              {/*
              <div className="bg-[#E5D07B] text-[#3E332E] rounded-xl p-8 shadow-md mt-8 h-40 flex flex-col justify-center items-center text-center">
                <p className="text-xl font-bold" style={{ fontFamily: 'var(--font-serif)' }}>
                  On vous rappelle sous 48h
                </p>
                <div className="space-y-2 text-[#3E332E]">
                  <p><strong>Lundi - Vendredi :</strong> 8h00 - 18h00</p>
                  <p><strong>Week-end :</strong> Sur rendez-vous</p>
                </div>
              </div>
              */}
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="section-title mb-8 text-4xl md:text-5xl" style={{ color: '#C24D36' }}>Demande de Devis</h2>
              
              {/* Le ref={form} est crucial ici pour que EmailJS trouve les champs */}
              <form ref={form} onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-[#3E332E] mb-2">
                    Nom complet *
                  </label>
                  <Input
                    id="name"
                    name="name" // Doit correspondre à {{name}} dans EmailJS
                    type="text"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Votre nom"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <Input
                    id="email"
                    name="email" // Doit correspondre à {{email}} dans EmailJS
                    type="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="votre@email.fr"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Téléphone
                  </label>
                  <Input
                    id="phone"
                    name="phone" // Doit correspondre à {{phone}}
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+33 1 23 45 67 89"
                  />
                </div>

                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                    Entreprise / Organisation
                  </label>
                  <Input
                    id="company"
                    name="company" // Doit correspondre à {{company}}
                    type="text"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Nom de votre organisation"
                  />
                </div>

                <div>
                  <label htmlFor="servings" className="block text-sm font-medium text-gray-700 mb-2">
                    Nombre de convives
                  </label>
                  <Input
                    id="servings"
                    name="servings" // Doit correspondre à {{servings}}
                    type="text"
                    value={formData.servings}
                    onChange={handleChange}
                    placeholder="Ex: 50-500 personnes"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Message *
                  </label>
                  <Textarea
                    id="message"
                    name="message" // Doit correspondre à {{message}}
                    required
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Décrivez votre projet..."
                    rows={6}
                  />
                </div>

                <Button type="submit" className="w-full btn-primary" disabled={submitting}>
                  {submitting ? 'Envoi en cours...' : 'Envoyer la demande'}
                  <Send className="ml-2" size={20} />
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;